/**
 * LaserArt quantity rules
 * Uses product metafields:
 * - custom.number_increased (N)
 * - custom.qty_fixed_set (boolean)
 *
 * Behavior when N > 0:
 * - Always enforce minimum N
 * - If qty_fixed_set = true: enforce multiples of N (N, 2N, 3N...)
 * - If qty_fixed_set = false: allow normal increments by 1 (N, N+1, N+2...)
 */
(function () {
  function toInt(v, fallback) {
    var n = parseInt(v, 10);
    return Number.isFinite(n) ? n : fallback;
  }

  function normalizeQty(qty, minN, fixedSet) {
    qty = toInt(qty, 0);
    minN = Math.max(1, toInt(minN, 1));
    fixedSet = String(fixedSet) === "1";

    if (qty <= 0) return 0;

    if (qty < minN) qty = minN;

    if (fixedSet && qty % minN !== 0) {
      qty = Math.ceil(qty / minN) * minN;
    }

    return qty;
  }

  function normalizeInput(input) {
    if (!input) return;

    var minN = input.dataset.numberIncreased || input.getAttribute("min") || "1";
    var fixedSet = input.dataset.qtyFixedSet || "0";

    var current = input.value;
    var normalized = normalizeQty(current, minN, fixedSet);

    if (String(normalized) !== String(current)) {
      input.value = String(normalized);
      input.dispatchEvent(new Event("change", { bubbles: true }));
    }
  }

  function isQtyRuleInput(el) {
    return el && el.matches && el.matches("input[data-number-increased]");
  }

  document.addEventListener("change", function (e) {
    if (isQtyRuleInput(e.target)) normalizeInput(e.target);
  });

  document.addEventListener(
    "blur",
    function (e) {
      if (isQtyRuleInput(e.target)) normalizeInput(e.target);
    },
    true
  );

  // Normalize product forms on submit
  document.addEventListener(
    "submit",
    function (e) {
      var form = e.target;
      if (!(form instanceof HTMLFormElement)) return;

      var input = form.querySelector("input[name='quantity'][data-number-increased]");
      if (input) normalizeInput(input);
    },
    true
  );
})();
